<template>
	<div class="animated fadeIn">

		<form @submit.prevent="validateBeforeSubmit">

			<div class="form-group row">
				<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Início (UTC):</label>
				<div class="col-sm-9">
					<input v-model="form.inicio" class="form-control form-control-sm" v-validate="'required'"
						style="display:none" name="inicio" :class="{ 'is-invalid': errors.has('inicio') }" />
					<date-picker ref="date" :clearable="true"
						:input-class="'form-control form-control-sm teste' + (errors.has('inicio') ? 'is-invalid' : '')"
						v-model="form.inicio" format="DD/MM/YYYY" type="date" lang="pt-br"></date-picker>
					<input v-model="form.hourInicio" type="time" id="appt" name="appt" min="00:00" max="23:59" required>
					<span class="invalid-feedback" v-show="errors.has('inicio')">{{ errors.first('inicio') }}</span>
				</div>
			</div>

			<div class="form-group row">
				<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Fim (UTC):</label>
				<div class="col-sm-9">
					<input v-model="form.fim" class="form-control form-control-sm" v-validate="'required'"
						style="display:none" name="fim" :class="{ 'is-invalid': errors.has('fim') }" />
					<date-picker ref="date" :clearable="true"
						:input-class="'form-control form-control-sm ' + (errors.has('fim') ? 'is-invalid' : '')"
						v-model="form.fim" format="DD/MM/YYYY" type="date" lang="pt-br"></date-picker>
					<input v-model="form.hourFim" type="time" id="apptFim" name="apptFim" min="00:00" max="23:59" required>
					<span class="invalid-feedback" v-show="errors.has('fim')">{{ errors.first('fim') }}</span>
				</div>
			</div>

			<div class="form-group row">
				<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Servidor:</label>
				<div class="col-sm-9">
					<!-- <pre>{{servidores}}</pre> -->
					<select v-model="form.idServidor" name="servidor" v-validate="'required'"
						:class="{ 'is-invalid': errors.has('servidor') }" class="form-control form-control-sm">
						<option value="">Escolha</option>
						<option v-for="item in servidores" :value="item.id" v-show="exibeServidor(item.id)" :key="item.id">
							{{ item.tipo }} - {{ item.descricao }}</option>

					</select>
					<span class="invalid-feedback" v-show="errors.has('servidor')">{{ errors.first('servidor') }}</span>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-sm-12 text-right">
					<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são
						obrigatórios.</small>
					<button class="btn btn-success btn-sm">
						<fa-icon icon="check" transform="left-3" /> REEENVIAR
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<style lang="scss">
.modal {
	.mx-datepicker {

		.mx-datepicker-popup {
			position: relative;
			top: 0px !important;
			left: 0px !important;

			.mx-calendar-content {
				width: 100%;
			}

			.mx-calendar-panel-time {
				width: 100%;
			}
		}
	}
}
</style>


<script>


import _ from 'lodash'
import moment from 'moment'
import axios from '../../../routers/axios';
export default {


	data() {
		return {
			equipamento: {},
			servidores: [],
			servidoresEnvio: [],
			form: {
				inicio: "",
				hourInicio: "",
				tipo: "",
				fim: "",
				hourFim: "",				
				idServidor: "",
				idEquipamento: ""
			}
		};
	},

	computed: {},

	mounted() {
		axios.get(this._getUrl("api/servidorenvio")).then(response => {
			this.servidores = response.data;
		});
	},

	methods: {
		exibeServidor(id) {
			for (var i = 0; i < this.servidoresEnvio.length; i++) {
				if (this.servidoresEnvio[i].idServidorEnvio == id) {
					return true;
				}
			}

			return false;
		},

		carregar(equipamento, tipo, inicio, fim) {
			this.equipamento = equipamento;
			this.form.idEquipamento = equipamento.id;

			if (!_.isNil(tipo)) {
				this.form.tipo = tipo
			}

			if (!_.isNil(inicio)) {
				this.form.inicio = inicio
			}

			if (!_.isNil(fim)) {
				this.form.fim = fim
			}
			this.carregaServidores(equipamento.id);
		},

		validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.envia();
				}
			});
		},


		envia() {

			var inicio = new moment(this.form.inicio).format("YYYY-MM-DD")
			var fim = new moment(this.form.fim).format("YYYY-MM-DD")

			inicio +=  ` ${this.form.hourInicio}`
			fim +=  ` ${this.form.hourFim}`

			var data = {
				inicio: inicio,
				fim: fim,
				idServidorEnvio: this.form.idServidor,
				idEquipamento: this.form.idEquipamento,
				tipo: this.form.tipo
			};

			this.$notify.loadIn('Reenviando')

			axios.post(this._getUrl("api/equipamentoreenvio"), data).then(response => {
				this.$notify.show('success',"Tudo ok! Será reenviado " + response.data + (data.tipo == "T" ? " trechos." : " posições."))
			});
		},

		carregaServidores(id) {
			axios.get(this._getUrl(`api/equipamentoenvio/${id}`)).then(response => {
				// console.log(response.data);
				this.servidoresEnvio = response.data;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/reenvio.vue